import { SearchX, Coffee, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { EmptyState, Button } from '../ui';
import './FeedEmpty.css';

interface FeedEmptyProps {
  variant: 'search' | 'cuisine' | 'geo';
  query?: string;
  onClearFilters: () => void;
}

export function FeedEmpty({ variant, query, onClearFilters }: FeedEmptyProps) {
  const { t } = useTranslation();

  const icon =
    variant === 'geo' ? <MapPin size={48} strokeWidth={1.5} /> :
    variant === 'cuisine' ? <Coffee size={48} strokeWidth={1.5} /> :
    <SearchX size={48} strokeWidth={1.5} />;

  const title =
    variant === 'geo' ? t('feed.geoTitle') :
    variant === 'cuisine' ? t('feed.emptyCuisine') :
    t('feed.emptySearchHeading');

  const sub =
    variant === 'search' && query
      ? t('feed.emptySearchBody', { q: query })
      : variant === 'cuisine'
        ? undefined
        : undefined;

  return (
    <div role="status" className="fe-wrap">
      <EmptyState
        icon={icon}
        title={title}
        sub={sub}
        action={
          <Button variant="secondary" size="sm" onClick={onClearFilters}>
            {t('feed.emptyClearCta')}
          </Button>
        }
      />
    </div>
  );
}
